
















import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { RichTextBoxInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import RichTextBoxObject from "../../../document/editor/objects/RichTextBoxObject.vue";
import RichTextBoxInputMethodSelector from "../inputMethodEditors/RichTextBoxInputMethodSelector.vue";
import ClipboardMenu from "./ClipboardMenu.vue";
import ObjectMenuButton from "./ObjectMenuButton.vue";

@Component({
  components: {
    ClipboardMenu,
    RichTextBoxInputMethodSelector,
    ObjectMenuButton,
  }
})
export default class RichTextObjectMenu extends Mixins() {
  @Prop()
  source: RichTextBoxObject;

  @Prop()
  isInputMethodSelectable: boolean;

  get selected(): RichTextBoxInputMethodKinds {
    return this.source.inputMethodKind;
  }

  set selected(value: RichTextBoxInputMethodKinds) {
    this.source.emitFocus();
    this.$nextTick(() => {
      this.source.inputMethodKind = value;
      this.source.setFocus();
    });
  }

  getButtonClass(kind: RichTextBoxInputMethodKinds): string {
    return Enumerable.from(this.buttonClasses)
      .first(c => c.key === kind)
      .class;
  }

  isVisible(kind: RichTextBoxInputMethodKinds): boolean {
    return !!this.getButtonClass(kind);
  }

  buttonClasses: { key: RichTextBoxInputMethodKinds, class: string }[] = [
    { key: RichTextBoxInputMethodKinds.None, class: "rich-text-object-menu-none" },
    { key: RichTextBoxInputMethodKinds.FreeInput, class: "rich-text-object-menu-free" },
    { key: RichTextBoxInputMethodKinds.MKSTemplate, class: "rich-text-object-menu-data" }, // TODO:アイコン差し替え.
    { key: RichTextBoxInputMethodKinds.DynamicTemplate, class: "rich-text-object-menu-data" }, // TODO:アイコン差し替え.
  ];
}
